var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "m11.92 9.08 1.41 1.41L16 7.83V20h2V7.83l2.66 2.67 1.42-1.42L17 4zM12.16 14.92l-1.41-1.41-2.67 2.66V4h-2v12.17L3.42 13.5 2 14.92 7.08 20z"
  })));
};
export default SvgSort;